export {default as AlsoKnownAs} from './AlsoKnownAs';
export {default as PDF} from './PDF';
export {default as Controls} from './Controls';
export {default as ContinuousGraph} from './ContinuousGraph';
export {default as DiscreteGraph} from './DiscreteGraph';
export {default as Statistics} from './Statistics';


// WEBPACK FOOTER //
// ./src/components/distributionComponents/index.js